import { useId } from 'react';

export interface TextInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  label?: string;
  value: string;
  onChange?: (value: string) => void;
  hint?: string;
}

export function TextInput({
  label,
  value,
  onChange,
  hint,
  id,
  className = '',
  ...rest
}: TextInputProps) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <div className={`text-input-wrapper ${className}`.trim()}>
      {label ? (
        <label className="field-label" htmlFor={fieldId}>
          {label}
        </label>
      ) : null}
      <input
        id={fieldId}
        type="text"
        className="text-input"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        aria-describedby={hint ? `${fieldId}-hint` : undefined}
        {...rest}
      />
      {hint ? <p id={`${fieldId}-hint`} className="field-hint">{hint}</p> : null}
    </div>
  );
}

export interface ToggleProps {
  label: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  id?: string;
  hint?: string;
}

export function Toggle({ label, checked, onChange, id, hint }: ToggleProps) {
  const autoId = useId();
  const toggleId = id ?? autoId;
  return (
    <div className="toggle-wrapper">
      <button
        type="button"
        id={toggleId}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        className={`toggle ${checked ? 'on' : ''}`.trim()}
        onClick={() => onChange?.(!checked)}
      >
        <span className="toggle-knob" aria-hidden="true" />
      </button>
      <span className="toggle-label">
        {label}
        {hint ? <span className="field-hint">{hint}</span> : null}
      </span>
    </div>
  );
}
